import { Component } from '@angular/core';

@Component({
  selector: 'sen-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'sen-app';
}
